import { render, staticRenderFns } from "./ModuleView.vue?vue&type=template&id=19432e7a&scoped=true"
import script from "./ModuleView.vue?vue&type=script&lang=js"
export * from "./ModuleView.vue?vue&type=script&lang=js"
import style0 from "./ModuleView.vue?vue&type=style&index=0&id=19432e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19432e7a",
  null
  
)

export default component.exports